module.exports = __webpack_public_path__ + "img/gu.08da5f87.svg";